import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "dialog-custom__content form-custom",
  style: {"width":"450px","height":"450px"}
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "bt-icon text-primary" }
const _hoisted_4 = { class: "dialog-custom__title my-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray text-center mt-5"
}
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "p-field-label mb-3" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "w-100 mb-4" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  class: "p-field-label mb-2",
  for: "problem-message"
}
const _hoisted_14 = { class: "text-gray" }
const _hoisted_15 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InlineSvgScoped, {
              src: require(`@/assets/images/icons/icon-mail.svg`),
              "aria-label": "icon-mail"
            }, null, 8, ["src"])
          ]),
          _createVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ReportaProblem")), 1)
        ]),
        (_ctx.step === 0)
          ? (_openBlock(), _createBlock("span", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (_ctx.plantDevices.length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$t('entrancePlant.noneGateConnected').split('\n'), (txt, index) => {
                        return (_openBlock(), _createBlock("span", { key: index }, [
                          _createVNode("p", _hoisted_8, _toDisplayString(txt), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResourceEP.SelectThePeYouWantToReport")), 1),
                      _createVNode(_component_ElScrollbar, { style: {"height":"300px","margin-right":"-20px","padding-right":"20px"} }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.plantDevices, (option, index) => {
                            return (_openBlock(), _createBlock(_component_ListItemRadio, {
                              key: index,
                              modelValue: _ctx.selectedDevice,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDevice = $event)),
                              label: `${option.device.deviceName ?? option.gate}`,
                              value: option.device,
                              name: "specificDevice",
                              inputId: 'specificDvc' + index,
                              last: index == _ctx.plantDevices.length - 1
                            }, null, 8, ["modelValue", "label", "value", "inputId", "last"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock("span", _hoisted_10, [
              _createVNode("form", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResource.DescribeTheProblem")), 1),
                  _createVNode(_component_Textarea, {
                    id: "problem-message",
                    class: "w-100 text-dark p-2",
                    rows: "6",
                    modelValue: _ctx.theMessage,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.theMessage = $event)),
                    style: {"resize":"none","border":"1px solid black"}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("small", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.ReportInfo")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("footer", _hoisted_15, [
        _createVNode(_component_Button, {
          class: "p-button-text p-button-secondary text-uppercase mr-2",
          onClick: _ctx.handleSecondaryButton
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.step === 0 ? _ctx.$t("AppResource.Cancel") : _ctx.$t("AppResource.Back")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          disabled: _ctx.primaryButtonDisabled,
          class: "p-button-rounded p-button--m",
          onClick: _ctx.handlePrimaryButton
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.step === 0 ? _ctx.$t("AppResource.Continue") : _ctx.$t("AppResource.SendUpper")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}